/* Maharaja Header - announcement rotator, smart header, mega menu, phone menu, search panel.
   Runs once; inits each [data-mm-header] and again when the theme editor reloads the section. */
(() => {
  'use strict';
  if (window.mmHeader) return;
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const designMode = window.Shopify && Shopify.designMode;
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  const init = el => {
    if (el.mmInit) return;
    el.mmInit = true;
    const ac = new AbortController();
    const opt = { signal: ac.signal };
    const hdr = $('[data-hdr]', el);
    const group = el.closest('#header-group') || el.parentElement;
    const scrim = $('[data-hdr-scrim]', el);
    const over = el.classList.contains('is-over');
    const smart = !designMode && el.dataset.smart !== 'false';
    const timers = [];

    /* ---------------- overlays: phone menu + search ---------------- */
    let openEl = null, lastFocus = null;
    const focusables = box => $$('a[href], button:not([disabled]), input:not([type="hidden"]), summary', box).filter(x => x.offsetParent !== null);
    const open = id => {
      const box = document.getElementById(id); if (!box) return;
      if (openEl) close(true);
      lastFocus = document.activeElement; openEl = box;
      box.inert = false; box.classList.add('is-open'); scrim.classList.add('is-on');
      $$(`[aria-controls="${id}"]`, el).forEach(b => b.setAttribute('aria-expanded', 'true'));
      document.documentElement.style.overflow = 'hidden';
      group.classList.remove('mm-hdr-hidden');
      setTimeout(() => { const f = $('[data-hdr-q]', box) || focusables(box)[0]; f && f.focus(); }, 80);
    };
    const close = keep => {
      if (!openEl) return;
      const id = openEl.id;
      openEl.classList.remove('is-open'); openEl.inert = true; openEl = null;
      $$(`[aria-controls="${id}"]`, el).forEach(b => b.setAttribute('aria-expanded', 'false'));
      if (!keep) { scrim.classList.remove('is-on'); document.documentElement.style.overflow = ''; lastFocus && lastFocus.focus && lastFocus.focus(); }
    };
    el.addEventListener('click', e => {
      const o = e.target.closest('[data-hdr-open]'); if (o) { e.preventDefault(); open(o.dataset.hdrOpen); return; }
      if (e.target.closest('[data-hdr-close]')) { close(); return; }
      if (openEl && e.target.closest('a[href]') && openEl.contains(e.target)) close();
    });
    scrim.addEventListener('click', () => close());
    const onKey = e => {
      if (e.key === 'Escape') { if (openEl) close(); closeMegas(); }
      if (e.key === 'Tab' && openEl) {
        const f = focusables(openEl); if (!f.length) return;
        const a = f[0], z = f[f.length - 1];
        if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
        else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
      }
    };
    document.addEventListener('keydown', onKey);
    // the theme's cart drawer opens over everything: close ours first
    const cartBtn = $('[data-hdr-cart]', el);
    if (cartBtn) cartBtn.addEventListener('click', () => close());

    /* ---------------- mega menus: hover in CSS, click + keyboard here ---------------- */
    const megas = $$('[data-mega]', el);
    const closeMegas = except => megas.forEach(m => { if (m === except) return; m.classList.remove('is-open'); $('.nl', m).setAttribute('aria-expanded', 'false'); });
    megas.forEach(m => {
      const btn = $('.nl', m);
      btn.addEventListener('click', () => { const on = !m.classList.contains('is-open'); closeMegas(m); m.classList.toggle('is-open', on); btn.setAttribute('aria-expanded', on); });
      m.addEventListener('mouseenter', () => { if (matchMedia('(hover: hover)').matches) btn.setAttribute('aria-expanded', 'true'); });
      m.addEventListener('mouseleave', () => { m.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); });
      m.addEventListener('focusout', e => { if (!m.contains(e.relatedTarget)) { m.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); } });
    });
    const onDocClick = e => { if (!e.target.closest('[data-mega]')) closeMegas(); };
    document.addEventListener('click', onDocClick);

    /* ---------------- announcement rotator ---------------- */
    const ann = $('[data-ann]', el);
    const msgs = ann ? $$('.ann-msg', ann) : [];
    if (msgs.length > 1 && !reduce) {
      let i = 0, paused = false;
      ['mouseenter', 'focusin'].forEach(t => ann.addEventListener(t, () => paused = true));
      ['mouseleave', 'focusout'].forEach(t => ann.addEventListener(t, () => paused = false));
      timers.push(setInterval(() => {
        if (paused || document.hidden) return;
        msgs[i].classList.remove('is-on'); i = (i + 1) % msgs.length; msgs[i].classList.add('is-on');
      }, 4000));
    }

    /* ---------------- smart header + see-through on the home image ---------------- */
    const main = document.getElementById('MainContent');
    // heights are measured only when they can change (resize, the slide ending, load), and the two
    // variables are written only when they differ: scrolling never makes the browser re-lay-out the page
    let groupH = 0, hdrH = 0, lastOff = '', lastHdr = '';
    const measure = () => { groupH = group.offsetHeight; hdrH = hdr.offsetHeight; };
    const setOffset = () => {
      const off = (group.classList.contains('mm-hdr-hidden') ? 0 : groupH) + 'px', hh = hdrH + 'px';
      if (off !== lastOff) { document.documentElement.style.setProperty('--mm-header-offset', off); lastOff = off; }
      if (hh !== lastHdr) { document.documentElement.style.setProperty('--header-height', hh); lastHdr = hh; }
    };
    const remeasure = () => { measure(); setOffset(); };
    // see-through: pull the first section up under the header
    const pullUp = () => { if (over && main) main.style.marginTop = -group.offsetHeight + 'px'; };
    const onResize = () => { pullUp(); remeasure(); };
    // the scroll position and the menu state are read in the scroll event, before anything on the page
    // has changed this frame; reading them inside the frame callback (after the scroll animations wrote
    // their styles) made the browser restyle the page mid-frame on every scroll step
    let lastY = scrollY, ticking = false, y = scrollY, busy = false;
    const read = () => {
      y = scrollY;
      busy = !!openEl || megas.some(m => m.classList.contains('is-open') || m.matches(':hover'));
    };
    // classes change only when their state changes: re-adding a class that is already there still
    // counts as a change in Chrome and sent the browser through a style check on every scroll step
    const setClass = (node, cls, on) => { if (node.classList.contains(cls) !== on) node.classList.toggle(cls, on); };
    const onScroll = () => {
      setClass(el, 'is-solid', y > 60);
      if (smart) {
        if (!busy && y > lastY + 4 && y > 240) setClass(group, 'mm-hdr-hidden', true);
        else if (y < lastY - 4 || y < 240) setClass(group, 'mm-hdr-hidden', false);
      }
      lastY = y; setOffset(); ticking = false;
    };
    const onScrollEv = () => { read(); if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } };
    addEventListener('scroll', onScrollEv, { passive: true });
    addEventListener('resize', onResize);
    group.addEventListener('transitionend', remeasure);
    addEventListener('load', remeasure, { once: true });
    if (over) { pullUp(); setTimeout(pullUp, 400); }
    measure();
    read();
    onScroll();

    /* ---------------- wishlist count (the theme keeps it live after the first paint) ---------------- */
    const paintWish = () => {
      let list = [];
      try { list = JSON.parse(localStorage.getItem('wishlistItem')) || []; } catch (e) { list = []; }
      $$('[data-wishlist-count]', el).forEach(c => { c.textContent = list.length; });
      $$('.wishlist-count-bubble', el).forEach(b => { b.style.display = list.length ? '' : 'none'; });
    };
    paintWish();
    ['add:wishlist-item', 'remove:wishlist-item'].forEach(t => document.addEventListener(t, () => setTimeout(() => { if (!ac.signal.aborted) paintWish(); }, 0), opt));

    /* ---------------- search: Shopify predictive search ---------------- */
    const q = $('[data-hdr-q]', el), res = $('[data-hdr-res]', el);
    if (q && res) {
      const money = v => {
        const n = parseFloat(v); if (isNaN(n)) return esc(v);
        const cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'INR';
        try { return new Intl.NumberFormat('en-IN', { style: 'currency', currency: cur, maximumFractionDigits: n % 1 ? 2 : 0 }).format(n); } catch (e) { return '₹ ' + n; }
      };
      let ctrl = null, t = null;
      // the theme's arrow (snippets/mm-theme-icons-template.liquid), with the line arrow as fallback
      const themeArrow = document.querySelector('#mm-theme-icons') && document.querySelector('#mm-theme-icons').content.querySelector('[data-icon="arrow"]');
      const arrow = themeArrow ? themeArrow.innerHTML.trim() : '<svg class="ic" viewBox="0 0 24 24" aria-hidden="true"><path d="M4 12h16m-6-6 6 6-6 6"/></svg>';
      const run = () => {
        const v = q.value.trim();
        if (ctrl) ctrl.abort();
        if (!v) { res.innerHTML = ''; res.classList.remove('is-busy'); return; }
        const request = ctrl = new AbortController();
        res.classList.add('is-busy');
        const url = `${root}search/suggest.json?q=${encodeURIComponent(v)}&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last`;
        fetch(url, { signal: request.signal })
          .then(r => r.json())
          .then(d => {
            if (request.signal.aborted || ac.signal.aborted) return;
            const ps = (d.resources && d.resources.results && d.resources.results.products) || [];
            const all = `${root}search?type=product&options%5Bprefix%5D=last&q=${encodeURIComponent(v)}`;
            res.innerHTML = ps.length
              ? `<p class="search-res-h">Sarees for “${esc(v)}”</p><div class="search-grid">${ps.map(p => {
                const img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
                const src = img ? img + (img.includes('?') ? '&' : '?') + 'width=360' : '';
                return `<a class="sr-item" href="${esc(p.url)}">${src ? `<img src="${esc(src)}" alt="" loading="lazy" width="360" height="480">` : '<span class="sr-ph"></span>'}<b>${esc(p.title)}</b><span>${money(p.price)}</span></a>`;
              }).join('')}</div><a class="link search-all" href="${all}">See all results ${arrow}</a>`
              : `<p class="search-res-h">No sarees found for “${esc(v)}”. Try a fabric or a colour.</p>`;
          })
          .catch(err => { if (err.name !== 'AbortError' && ctrl === request && !ac.signal.aborted) res.innerHTML = ''; })
          .finally(() => { if (ctrl === request) res.classList.remove('is-busy'); });
      };
      q.addEventListener('input', () => { clearTimeout(t); t = setTimeout(run, 220); });
      $$('[data-hdr-pop]', el).forEach(b => b.addEventListener('click', () => { q.value = b.textContent.trim(); run(); q.focus(); }));
      ac.signal.addEventListener('abort', () => { clearTimeout(t); if (ctrl) ctrl.abort(); });
    }

    el.mmDestroy = () => {
      ac.abort();
      timers.forEach(clearInterval);
      removeEventListener('scroll', onScrollEv);
      removeEventListener('resize', onResize);
      document.removeEventListener('keydown', onKey);
      document.removeEventListener('click', onDocClick);
      group.removeEventListener('transitionend', remeasure);
      if (over && main) main.style.marginTop = '';
      group.classList.remove('mm-hdr-hidden');
      document.documentElement.style.overflow = '';
    };
  };

  const initAll = () => $$('[data-mm-header]').forEach(init);
  window.mmHeader = { init: initAll };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', e => { const el = $('[data-mm-header]', e.target); if (el) init(el); });
  document.addEventListener('shopify:section:unload', e => { const el = $('[data-mm-header]', e.target); if (el && el.mmDestroy) el.mmDestroy(); });
})();
